module.exports = __webpack_public_path__ + "img/ring_y_l_0_null@3x.dd7759b1.png";